import React from 'react';
import { CheckIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { checkoutUrl, productBrand, productEdition } from '../data/offer';
const assurances = ['7-day guarantee', 'Secure payment', 'Instant access'];
export function FinalCta() {
  return <section className="border-t border-primary/40 bg-surface py-16 sm:py-20" aria-labelledby="final-title" data-id="element-58" data-mp="15ddjbc9f61kl">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-59" data-mp="1jcvc02pu5yz8">
        <h2 id="final-title" className="text-balance text-3xl font-extrabold uppercase tracking-tight text-foreground sm:text-4xl" data-id="element-60" data-mp="1jbaj0hj66o3h">
          <span className="inline-flex items-center gap-2" data-id="element-61" data-mp="1t2omt1i5ma2f">
            <ZapIcon className="glow-led h-8 w-8 shrink-0 text-highlight" aria-hidden="true" data-id="element-62" data-mp="1t252xf8y1blr" /> {productBrand}
          </span>
          <span className="mt-2 block text-xl font-extrabold uppercase tracking-[.16em] text-accent sm:text-2xl" data-id="element-63" data-mp="223mgapuyuz6r">
            {productEdition}
          </span>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-lg leading-relaxed text-muted" data-id="element-64" data-mp="1x6cv5mem19oq">
          Created for electrical engineers, technicians and power system professionals worldwide.
        </p>

        <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-8 w-full sm:w-auto" data-id="element-65" data-mp="s57fd5g43ssb">
          Get my professional edition now
        </Button>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-muted" data-id="element-66" data-mp="123wn45eanwuu">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-67" data-mp="162dxqywxbph0">
              <CheckIcon className="glow-led h-4 w-4 text-highlight" aria-hidden="true" data-id="element-68" data-mp="1b28ngz4yq90h" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}